import { render, staticRenderFns } from "./SurveysPublicV2.vue?vue&type=template&id=31b022e4&scoped=true"
import script from "./SurveysPublicV2.vue?vue&type=script&lang=js"
export * from "./SurveysPublicV2.vue?vue&type=script&lang=js"
import style0 from "./SurveysPublicV2.vue?vue&type=style&index=0&id=31b022e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b022e4",
  null
  
)

export default component.exports